// import * as internal from 'stream'
import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity()
export class Itemconfiguration {
    @PrimaryGeneratedColumn()
    id: number;

    @Column('varchar', {
        name: 'item',
    })
    item: string;

    @Column('mediumblob')
    image: Buffer;

    @Column('varchar', {
        name: 'imagename',
    })
    imagename: string;

    @Column('varchar', {
        name: 'mimetype',
    })
    mimetype: string;

    @Column('varchar', {
        name: 'originalname',
    })
    originalname: string;

    @Column('varchar', {
        name: 'path',
    })
    path: string;

    @Column('int')
    size: number;
}
